import { useState } from "react";
import { History, ChevronDown, ChevronRight } from "lucide-react";

const LABELS = {
  moved_to_bin: { text: "Moved to bin", cls: "border-amber-300 bg-amber-50 text-amber-800" },
  restored: { text: "Restored", cls: "border-emerald-300 bg-emerald-50 text-emerald-800" },
  purged: { text: "Purged", cls: "border-red-300 bg-red-50 text-red-700" },
  deleted_forever: { text: "Deleted forever", cls: "border-red-300 bg-red-50 text-red-700" },
  auto_purged: { text: "Auto-purged", cls: "border-zinc-300 bg-zinc-50 text-zinc-700" },
};

const fmtTime = (isoStr) => {
  const d = new Date(isoStr);
  return `${d.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" })} ${d.toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit", hour12: false })}`;
};

export function DeletionHistory({ rows }) {
  const [open, setOpen] = useState(true);
  if (!rows.length) return null;
  return (
    <section className="mt-10" data-testid="deletion-history-panel">
      <button onClick={() => setOpen(!open)} data-testid="deletion-history-toggle" className="flex w-full items-center gap-2 border-t border-black/10 pt-6 text-left">
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        <History className="h-4 w-4 text-[#002FA7]" />
        <span className="font-display text-xl font-black tracking-tighter">Deletion history</span>
        <span className="text-sm text-zinc-400">({rows.length})</span>
      </button>
      {open ? (
        <div className="mt-3 overflow-x-auto border border-black/10 bg-white">
          <table className="w-full text-left text-xs">
            <thead className="bg-zinc-50 text-[10px] uppercase tracking-widest text-zinc-500">
              <tr><th className="px-3 py-2">When</th><th className="px-3 py-2">Event</th><th className="px-3 py-2">Action</th><th className="px-3 py-2">By</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const l = LABELS[r.action] || { text: r.action, cls: "border-zinc-300 text-zinc-700" };
                return (
                  <tr key={r.id} className="border-t border-black/5" data-testid={`deletion-log-row-${r.id}`}>
                    <td className="whitespace-nowrap px-3 py-2 font-mono">{fmtTime(r.at)}</td>
                    <td className="px-3 py-2 font-semibold">{r.event_name}</td>
                    <td className="px-3 py-2"><span className={`inline-block border px-1.5 py-0.5 text-[10px] font-black uppercase tracking-widest ${l.cls}`}>{l.text}</span></td>
                    <td className="px-3 py-2 text-zinc-600">{r.by_email}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </section>
  );
}
